<template>
<v-card max-width="344" color="#f0f0f0" flat>
    <v-list-item>
        <v-list-item-avatar color="grey">
            <v-img :src="`https://api.adorable.io/avatars/164/${this.$store.state.user}`"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title class="headline text-primary font-weight-black text-h6">Menú principal</v-list-item-title>
            <v-list-item-subtitle><span class="text font-weight-black">Usuario:</span> {{this.$store.state.user}}</v-list-item-subtitle>
        </v-list-item-content>
    </v-list-item>
    <v-card-actions>
        <v-btn depressed color="primary" to="/dashboard">
            Home
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="error" @click="logout">
            Cerrar sesión
        </v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
export default {
    name: 'Menu',
    methods: {
        logout() {
            this.$store.dispatch('setToken', null);
            this.$store.dispatch('setUser', null);
            this.$router.push('/');
        }
    }
}
</script>
